import React, { useEffect, useState, useMemo, useCallback } from "react";
import WorkflowElement from "../../app/components/WorkflowElement";
import { useDispatch } from "react-redux";
import { taskDone } from "../../app/store/WorkflowEngine";
import { useNavigate } from "react-router-dom";
import { useLoadAppUpdatesQuery } from "../../app/store/applicationApiSlice";
import { useLoadWorkflowTaskQuery, useLoadCurrentWorkflowTaskMutation } from "../../app/store/workflowApiSlice";

const DYNAMIC_HTML_STYLES = {
  card: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fcfdff 100%)",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  cardHeader: {
    padding: "20px 22px 18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap"
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  titleIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(79, 70, 229, 0.1) 100%)",
    color: "#4f46e5",
    fontSize: "16px",
    border: "1px solid rgba(224, 231, 255, 0.8)",
    flexShrink: 0
  },
  titleText: {
    display: "flex",
    flexDirection: "column",
    gap: "2px"
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.2,
    margin: 0
  },
  cardSubtitle: {
    fontSize: "13px",
    color: "#64748b",
    margin: 0
  },
  cardBody: {
    padding: "24px 22px"
  },
  closeButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 700,
    transition: "all 0.2s ease",
    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)"
  }
};

const DynamicHtml = (props) => {
  const { handleBack, workItem } = props;

  const usrType = localStorage.getItem("userType");

  const [workflowTask, setWorkflowTask] = useState(null);
  const [reqCount, setReqCount] = useState(0);

  const { data: appUpdates = [] } = useLoadAppUpdatesQuery(workItem?.ciid, { skip: !workItem?.ciid });
  const { data: workflowTaskQueryData } = useLoadWorkflowTaskQuery(
    workItem?.wiid || workItem?.id,
    { skip: !workItem?.wiid && !workItem?.id }
  );

  const [loadCurrentWfTask, { data: currentWfTaskData }] = useLoadCurrentWorkflowTaskMutation();

  const updatedStateData = useMemo(() => {
    if (appUpdates.length > 0) {
      const lastUpdated = appUpdates[appUpdates.length - 1];
      return lastUpdated.stateData;
    }
    return "";
  }, [appUpdates]);

  let appType = "Onboarding Form";
  if (usrType === "candidate") {
    appType = "Onboarding Form";
  }

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (workItem?.ciid > 0) {
      setWorkflowTask(workItem);
    }
  }, [workItem]);

  useEffect(() => {
    let timer;
    if (workflowTaskQueryData?.id > 0) {
      setWorkflowTask(workflowTaskQueryData);
    } else if (reqCount <= 2 && workflowTask) {
      timer = setTimeout(() => {
        loadCurrentWfTask(workflowTask);
        setReqCount(1);
      }, 3000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [workflowTaskQueryData, reqCount, workflowTask, loadCurrentWfTask]);

  useEffect(() => {
    let timer;
    if (currentWfTaskData?.formId === null && reqCount <= 3) {
      timer = setTimeout(() => {
        loadCurrentWfTask(workItem);
        setReqCount((prev) => prev + 1);
      }, 3000);
    } else if (currentWfTaskData?.wiid > 0) {
      setWorkflowTask(currentWfTaskData);
    } else if (reqCount > 3) {
      setWorkflowTask(null);
      dispatch(taskDone(""));
      navigate("/Onboarding");
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [currentWfTaskData, reqCount, workItem, loadCurrentWfTask, dispatch, navigate]);

  const handleNextTask = useCallback((type) => {
    if (type === "submit" || type === "updateAndSubmit" || type === "checkStatus"
      || type === "taskDoneAndExit" || type === "saveAndExit") {
      setTimeout(() => {
        setWorkflowTask(null);
        dispatch(taskDone(""));
        window.location.href = "/Onboarding";
      }, 2000);
    }
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="col-md-12 mt-3 form-group">
        <div style={DYNAMIC_HTML_STYLES.card}>
          <div style={DYNAMIC_HTML_STYLES.cardHeader}>
            <div style={DYNAMIC_HTML_STYLES.headerRow}>
              <div style={DYNAMIC_HTML_STYLES.titleRow}>
                <div style={DYNAMIC_HTML_STYLES.titleIcon}>
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                </div>
                <div style={DYNAMIC_HTML_STYLES.titleText}>
                  <div style={DYNAMIC_HTML_STYLES.cardTitle}>{appType}</div>
                  <p style={DYNAMIC_HTML_STYLES.cardSubtitle}>
                    {workflowTask?.taskName || "Please complete the required information below."}
                  </p>
                </div>
              </div>
              <button
                style={DYNAMIC_HTML_STYLES.closeButton}
                onClick={handleBack}
              >
                <i className="fa fa-times" aria-hidden="true"></i>
                Close
              </button>
            </div>
          </div>

          <div style={DYNAMIC_HTML_STYLES.cardBody}>
            <div className="row">
              <div className="col-md-12">
                <WorkflowElement
                  wfTask={workflowTask}
                  handleNextTask={handleNextTask}
                  saveBtnProcessStatus={false}
                  actionType=""
                  viewType={workflowTask?.taskState === 4 ? false : false}
                  updatedStateData={updatedStateData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default DynamicHtml;
